// Lê o peso do agente local de balança (roda no próprio PC do caixa —
// ver /agente-balanca na raiz do repo). Chamada direta em localhost, NUNCA
// passa pelo backend do ERP nem pela instância `api` (sem token/CORS do
// nosso domínio envolvidos) — por isso usa fetch puro, não o axios `api`.
const BALANCA_URL = 'http://localhost:9099/api/peso';
const TIMEOUT_MS = 5000;

export async function lerPesoBalanca() {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
  let resp;
  try {
    resp = await fetch(BALANCA_URL, { signal: controller.signal });
  } catch (err) {
    if (err.name === 'AbortError') {
      throw new Error('A balança não respondeu a tempo.');
    }
    throw new Error(
      'Não foi possível conectar ao agente de balança neste computador (http://localhost:9099). ' +
      'Verifique se ele está instalado e rodando.'
    );
  } finally {
    clearTimeout(timer);
  }

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data.erro || 'Erro ao ler a balança.');
  return data.peso;
}
